var _themes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
import tscStyles from '../constants/TscStyles';
import TscThemeName from '../constants/TscThemeName';
import { getClassName } from '../utils/get-class-name';
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  spinner: {
    stroke: tscStyles.color.text.medium
  }
}), _defineProperty(_themes, TscThemeName.dusk, {
  spinner: {
    stroke: tscStyles.color.text.light
  }
}), _themes);
var spin = keyframes(["100%{transform:rotate(360deg);}"]);
var dash = keyframes(["0%{stroke-dasharray:0 150;stroke-dashoffset:0;}47.5%{stroke-dasharray:42 150;stroke-dashoffset:-16;}95%,100%{stroke-dasharray:42 150;stroke-dashoffset:-59;}"]);
var Container = styled.div.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "Spinner__Container"
})(["margin:0 auto;width:48px;height:48px;text-align:center;font-size:10px;svg{.spinner{transform-origin:center;animation:", " 2s linear infinite;}.spinner circle{stroke-linecap:round;animation:", " 1.5s ease-in-out infinite;stroke:", ";}}"], spin, dash, function (props) {
  return themes[props.themeName].spinner.stroke;
});

var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      testId = _ref.testId,
      _ref$themeName = _ref.themeName,
      themeName = _ref$themeName === void 0 ? TscThemeName.dawn : _ref$themeName;
  return _jsx(Container, {
    className: getClassName(className, null, 'spinner-container'),
    testId: testId,
    themeName: themeName,
    children: _jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 24 24",
      children: _jsx("g", {
        className: "spinner",
        children: _jsx("circle", {
          cx: "12",
          cy: "12",
          r: "9.5",
          fill: "none",
          strokeWidth: "1.5"
        })
      })
    })
  });
};

var SpinnerTest = {
  Container: Container
};
export { Spinner, SpinnerTest };
export default Spinner;